module.exports = __webpack_public_path__ + "static/img/TW@3x.76279110.jpg";